const createPageAction = (
    actionName: string,
    params: Record<string, string | number | Error>
) => {
    const newRelic = window.newrelic;

    if (newRelic === undefined) {
        return;
    }

    newRelic.addPageAction(actionName, {
        ...params,
        pageUrl: window?.location.href
    });
};

const noticeError = (error: string | Error, customAttrs = {}) => {
    const newRelic = window.newrelic;

    if (newRelic === undefined) {
        return;
    }

    if (error instanceof Error) {
        newRelic.noticeError(error, {
            ...customAttrs,
            pageUrl: window?.location.href,
            ...('requestUrl' in error
                ? { requestUrl: error.requestUrl as string }
                : {})
        });
        return;
    }

    const fixedError = new Error(`Unknown error type '${typeof error}'`);
    newRelic.noticeError(fixedError, {
        ...customAttrs,
        pageUrl: window?.location.href
    });
};

const setCustomAttribute = (attribute: string, value: string) => {
    const newRelic = window.newrelic;
    if (newRelic === undefined) {
        return;
    }

    newRelic.setCustomAttribute(attribute, value);
    return;
};

const newRelic = {
    createPageAction,
    setCustomAttribute,
    noticeError
};
export default newRelic;
